import { useState } from 'react';
import { createRoot } from 'react-dom/client';

import { BrowserRouter, Route, Routes, Link } from "react-router-dom"

import Box from '@mui/material/Box'

import Header from "./Header";

import Formular from './Section3/Formular';

import Footer3 from './Footer3';

function Part3() {

  return (

    <>

        <Formular />

        <Footer3 />

    </>

  );
}

export default Part3;
